
<div *ngIf="webserviceLayout && value[webserviceLayout.fieldName] != null" class="d-flex flex-column" >
    
    @if (value[webserviceLayout.fieldName] != null) {

        <div class="repeat-title d-flex flex-column justify-content-center">
            <div class=" mat-subheading-1 ">{{webserviceLayout.name}}</div>          
        </div>

        <ng-container *ngFor="let data of webserviceLayout.items; let index = index">

            <app-dynamic-view-row-layout [layout]="data" [value]="value[webserviceLayout.fieldName]" [fieldVisibility]="fieldVisibility">

            </app-dynamic-view-row-layout>
            
        </ng-container>

    }
    @else {

        <div class="d-flex flex-column justify-content-center webservice-section error">
            <div class="eac-body-2 valign-center" style="min-height: 36px; width: 80%;">
                {{webserviceLayout.titleError}}
            </div>
            <div class="valign-center eac-c1">
                <quill-view-html [content]="webserviceLayout.descriptionError"></quill-view-html>
            </div>
        </div>

    }
    
</div>